import { Component, ElementRef, HostListener, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';

import * as echarts from 'echarts/core';
import {
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  DataZoomComponent,
} from 'echarts/components';
import { LineChart } from 'echarts/charts';
import { UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';
import { LargeArea } from 'src/app/Interfaces/Admin/charts/LargeChartArea.interface';


@Component({
    selector: 'app-large-chart-arearc',
    templateUrl: './large-chart-arearc.component.html',
    styleUrls: ['./large-chart-arearc.component.scss', '../../../../Components/Styles/GlobalStyles.css'],
    standalone: false
})
export class LargeChartArearcComponent implements OnInit, OnChanges {

  //+===================== INPUTS =====================+\\
  @Input() DataChartArea!: LargeArea;

  //+================== VARIABLES FOR CHART ==================+\\
  @ViewChild('largeChart', { static: true }) chartContainer!: ElementRef;

  //+================== VARIABLES FOR CHART ==================+\\
  public MyChart: any;

  ngOnInit(): void {

    echarts.use([
      TitleComponent,
      ToolboxComponent,
      TooltipComponent,
      GridComponent,
      DataZoomComponent,
      LineChart,
      CanvasRenderer,
      UniversalTransition
    ]);

    this.MyChart = echarts.init(this.chartContainer.nativeElement);
    this.updateChart();

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['DataChartArea'] && !changes['DataChartArea'].firstChange) {
      this.updateChart();
    }

  }

  //-================== LOAD CHART OPTIONS AND DATA ==================-\\
  private getChartOptions() {

    const option = {
      tooltip: {
        trigger: 'axis',
        position: function (pt: any) {
          return [pt[0], '10%'];
        }
      },
      title: {
        left: 'center',
        text: this.DataChartArea.Title,
        subtext: this.DataChartArea.Subtitle,
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: this.DataChartArea.Date
      },
      yAxis: {
        type: 'value',
      },
      dataZoom: [
        {
          type: 'inside',
          start: 0,
          end: 100
        },
        {
          start: 0,
          end: 10
        }
      ],
      series: [
        {
          name: this.DataChartArea.SerieName,
          type: 'line',
          symbol: 'none',
          sampling: 'lttb',
          itemStyle: {
            color: '#20a8e1'
          },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: '#20a8e1'
              },
              {
                offset: 1,
                color: '#24FAFF'
              }
            ])
          },
          data: this.DataChartArea.Data
        }
      ]
    };

    return option

  }

  private updateChart(): void {
    const options = this.getChartOptions();
    this.MyChart.resize();
    this.MyChart.setOption(options);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    if (this.MyChart) {
      this.MyChart.resize();
    }
  }
}
